import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class NerService {

  constructor(private http: HttpClient) { }

  getTerms(type: string, filter: any): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/ner/terms/${type}`,
        filter
      );
  }

  deleteTerm(type: string, id: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/admin/ner/terms/${type}/${id}`
      );
  }

  addTermFromTest(type: string, term: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/ner/terms/add/${type}`,
        { term: term }
      );
  }

  deleteTermFromTest(type: string, term: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/ner/terms/remove/${type}`,
        { term: term }
      );
  }

  extract(id: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/ner/extract/${id}`
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/ner.service.ts